namespace $ {

	$mol_style_define( $shm_hitalama_projects, {

		Projects_menu: {
			padding: 0,
		},

	} )

}
